module.exports = __webpack_public_path__ + "static/media/truck-origin.fb121806.svg";